import { Icon } from "@chakra-ui/icons";

interface Props {
  color?: string;
  boxSize?: string;
}
export const TagOutline = (props: Props) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path
      d="M6.91111 5.24219L2.15527 9.99802L6.91111 14.7539L8.08944 13.5755L4.51194 9.99802L8.08944 6.42052L6.91111 5.24219ZM13.0894 14.7539L17.8453 9.99802L13.0894 5.24219L11.9111 6.42052L15.4886 9.99802L11.9111 13.5755L13.0894 14.7539Z"
      fill="currentColor"
    />
  </Icon>
);

export default TagOutline;
